import React from 'react';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div className="text-center">
          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Professional Video Editing
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500">
              Made Simple
            </span>
          </h1>
          
          {/* Subheadline */}
          <p className="text-xl sm:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Extract scenes from videos automatically or merge multiple clips seamlessly.
            Fast and easy to use.
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => navigate('/extraction')}
              className="w-full sm:w-auto px-8 py-4 bg-blue-500 hover:bg-blue-600 text-white text-lg font-semibold rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
            >
              Try Shot Extraction →
            </button>
            <button
              onClick={() => navigate('/merge')}
              className="w-full sm:w-auto px-8 py-4 border-2 border-blue-500 hover:bg-blue-500/10 text-blue-400 hover:text-blue-300 text-lg font-semibold rounded-lg transition-all duration-200"
            >
              Try Video Merge
            </button>
          </div>
          
          {/* Trust indicator */}
          <p className="mt-8 text-sm text-gray-400">
            🔒 Your videos are processed securely and never stored permanently!
          </p>
        </div>
      </div>
      
      {/* Background gradient effect */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-96 bg-gradient-to-b from-blue-500/10 to-transparent blur-3xl -z-10" />
    </section>
  );
};

export default Hero;
